import { render, staticRenderFns } from "./RichEditor.vue?vue&type=template&id=e99a7cb0&scoped=true"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"
import style0 from "./RichEditor.vue?vue&type=style&index=0&id=e99a7cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99a7cb0",
  null
  
)

export default component.exports